import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class FeaturesV1 extends Component {

    render() {

    let publicUrl = process.env.PUBLIC_URL+'/'

    let customClass = this.props.customClass ? this.props.customClass :''

    return <div className={ customClass } >
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-12">
			        <div className="section-title-area ltn__section-title-2--- text-center">
			          <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Success Property Enterprises</h6>
			          <h1 className="section-title">Ongoing Projects</h1>
			        </div>
			      </div>
			    </div>
			    <div className="row ltn__custom-gutter--- justify-content-center go-top">
			      <div className="col-lg-6 col-sm-6 col-12">
			        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
			          <div className="ltn__feature-imgs">
			            <img src={publicUrl+"assets/img/banner/img1.png"} alt="#" />
			          </div>
			          <div className="ltn__feature-info mt-3">
			            <h3>Metrro City</h3>
			            <p>Buying a plot is considered one of the safest and highly profitable real estate investments in Chennai</p>
			            <Link className="ltn__service-btn" to="/product-details">Find a Plot <i className="flaticon-right-arrow" /></Link>
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-6 col-sm-6 col-12">
			        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
			          <div className="ltn__feature-imgs">
			            <img src={publicUrl+"assets/img/projects/Hari Nagar/img2.jpg"} alt="#" />
			          </div>
			          <div className="ltn__feature-info mt-3">
			            <h3>Sri Hari Nagar</h3>
			            <p>A Plot  are stand-alone structures that offer a comfortable real estate investments in Chennai</p>
			            <Link className="ltn__service-btn" to="/product-details1">Find a Plot <i className="flaticon-right-arrow" /></Link>
			          </div>
			        </div>
			      </div>
			      {/* <div className="col-lg-4 col-sm-6 col-12">
			        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
			          <div className="ltn__feature-icon">
			            <img src={publicUrl+"assets/img/icons/icon-img/21.png"} alt="#" />
			          </div>
			          <div className="ltn__feature-info">
			            <h3></h3>
			            <p>Over 100+ Plot for sale available, we can match you with a Plot you will want.</p>
			            <Link className="ltn__service-btn" to="#">Find a Plot <i className="flaticon-right-arrow" /></Link>
			          </div>
			        </div>
			      </div> */}
			    </div>
			  </div>
			</div>
        }
}

export default FeaturesV1